<template>
  <component
    :is="kind"
    v-bind="block"
    :mode="mode"
    :activeItem="activeItem"
    @add="$emit('add')"
    @click-item="$emit('click-item', $event)"
    @delete-item="$emit('delete-item', $event)"
  />
</template>

<script>
import BigCarousel from './BigCarousel.vue'
import MediumCarousel from './MediumCarousel.vue'
import SmallCarousel from './SmallCarousel.vue'
import SingleCard from './SingleCard.vue'
import List from './List.vue'

export default {
  components: {
    BigCarousel,
    MediumCarousel,
    SmallCarousel,
    SingleCard,
    List,
  },
  props: {
    kind: {
      type: String,
      required: true
    },
    block: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
    activeItem: {
      type: Object,
      default: null,
    }
  },
  setup() {
    return {}
  }
}
</script>